import { render, staticRenderFns } from "./RegionsDialog.vue?vue&type=template&id=7a152a4e&"
import script from "./RegionsDialog.vue?vue&type=script&lang=ts&"
export * from "./RegionsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports